{
  "user": {
    "form": {
      "addTitle": "ユーザーを作成",
      "editTitle": "ユーザーを編集",
      "fields": {
        "username": "ユーザー名",
        "email": "メールアドレス",
        "fullName": "氏名",
        "password": "パスワード",
        "confirmPassword": "パスワード（確認）",
        "facility": "施設",
        "roles": "ロール",
        "active": "有効",
        "allFacilities": "全施設（ヘルスシステム全体）",
        "globalAccessAck": "すべての施設へのアクセスを許可することを理解しました",
        "departments": "部門",
        "primaryDepartment": "主部門",
        "roleFacility": "{{role}} の施設",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ 施設を追加",
        "removeFacilityFromRole": "1件削除",
        "otherRoles": "その他"
      },
      "errors": {
        "usernameMin": "ユーザー名は{{min}}文字以上で入力してください",
        "emailInvalid": "メールアドレスの形式が正しくありません",
        "passwordMin": "パスワードは{{min}}文字以上で入力してください",
        "confirmPasswordRequired": "確認用パスワードを入力してください",
        "passwordMismatch": "パスワードが一致しません",
        "rolesRequired": "ロールを1つ以上選択してください",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "保存する前にヘルスシステム全体の許可を確認してください。"
      },
      "submit": {
        "create": "ユーザーを作成",
        "update": "ユーザーを更新"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "ユーザーを作成しました",
        "updatedSuccess": "ユーザーを更新しました",
        "saveError": "ユーザーの保存に失敗しました",
        "departmentsSaveError": "ユーザーは保存されましたが、部門の割り当てに失敗しました。編集して再試行してください。"
      },
      "globalAccessWarning": "これは呼び出し範囲だけでなく、「すべての」施設の患者へのアクセスを許可します。オンコール要員など、真にヘルスシステム全体を担当する職員にのみ使用してください。",
      "departmentsHint": "このアカウントが勤務する部門です。記録の帰属のみに使用され、患者へのアクセス権は付与しません。",
      "noDepartments": "部門がまだ設定されていません。"
    },
    "list": {
      "title": "ユーザー管理",
      "subtitle": "システムユーザー、ロール、アクセスを管理",
      "columns": {
        "username": "ユーザー名",
        "fullName": "氏名",
        "email": "メール",
        "roles": "ロール",
        "facility": "施設",
        "status": "ステータス",
        "lastLogin": "最終ログイン",
        "actions": "操作",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "ユーザーを検索...",
        "allRoles": "すべてのロール",
        "allFacilities": "すべての施設",
        "allStatus": "すべてのステータス",
        "active": "有効",
        "inactive": "無効"
      },
      "actions": {
        "new": "ユーザーを作成",
        "editTitle": "ユーザーを編集",
        "resetPasswordTitle": "パスワードをリセット",
        "activate": "有効化",
        "deactivate": "無効化",
        "activateAria": "ユーザーを有効化",
        "deactivateAria": "ユーザーを無効化"
      },
      "lastLoginNever": "なし",
      "empty": "条件に一致するユーザーが見つかりません",
      "pagination": {
        "summary": "{{total}} 件中 {{from}}-{{to}} 件を表示"
      },
      "toast": {
        "activated": "ユーザー {{username}} を有効化しました",
        "deactivated": "ユーザー {{username}} を無効化しました",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "全施設",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "有効",
      "inactive": "無効",
      "locked": "ロック中",
      "pendingActivation": "有効化待ち"
    },
    "mfaStatus": {
      "enrolled": "登録済み",
      "notEnrolled": "未登録",
      "exempt": "免除"
    }
  },
  "role": {
    "form": {
      "addTitle": "ロールを作成",
      "editTitle": "ロールを編集",
      "fields": {
        "name": "ロール名",
        "code": "ロールコード",
        "description": "説明",
        "category": "カテゴリ",
        "parentRole": "親ロール（権限を継承）"
      },
      "options": {
        "none": "なし"
      },
      "errors": {
        "nameRequired": "ロール名を入力してください",
        "codeRequired": "ロールコードを入力してください"
      },
      "submit": {
        "create": "ロールを作成",
        "update": "ロールを更新"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "ロールを作成しました",
        "updatedSuccess": "ロールを更新しました",
        "saveError": "ロールの保存に失敗しました"
      }
    },
    
    "status": {
      "active": "有効",
      "inactive": "無効"
    },
    "source": {
      "own": "自身",
      "inherited": "継承",
      "category": "カテゴリ"
    },
    "permissions": {
      "ownTitle": "権限を編集",
      "deniedTitle": "拒否権限を編集",
      "ownSubtitle": "{{total}}件中{{granted}}件を付与。継承およびカテゴリ既定の権限はアクセスマトリクスに表示されます。このページではロール自体の付与のみを管理します。",
      "deniedSubtitle": "拒否権限は、ロール自体の権限、親ロール、およびカテゴリ既定からの付与を上書きします。チェックすると、このロールでその権限を明示的に拒否します。",
      "invalidRoleId": "ロール ID が無効です。",
      "save": "権限を保存",
      "saveDenied": "拒否権限を保存",
      "cancel": "キャンセル",
      "toast": {
        "updatedSuccess": "権限を更新しました",
        "deniedUpdatedSuccess": "拒否権限を更新しました",
        "saveError": "権限の保存に失敗しました",
        "saveDeniedError": "拒否権限の保存に失敗しました"
      },
      "permissionGroup": {
        "analytics": "分析",
        "audit": "監査",
        "billing": "請求",
        "bloodProduct": "血液製剤",
        "consent": "同意",
        "dietOrder": "食事オーダ",
        "discharge": "退院",
        "documentation": "記録",
        "encounter": "受診",
        "infection": "感染管理",
        "licensing": "ライセンス",
        "medication": "薬剤",
        "notification": "通知",
        "order": "オーダ",
        "patient": "患者",
        "referral": "紹介",
        "research": "研究",
        "restraint": "身体拘束",
        "result": "結果",
        "scheduling": "スケジュール",
        "system": "システム",
        "transfer": "転送",
        "user": "ユーザー",
        "schedule": "スケジュール",
        "admin": "管理",
        "report": "レポート",
        "other": "その他"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "カテゴリーを作成",
      "editTitle": "カテゴリーを編集",
      "fields": {
        "name": "カテゴリー名",
        "code": "カテゴリーコード",
        "description": "説明",
        "sessionTimeout": "セッションタイムアウト（分）",
        "maxFailedLogins": "最大ログイン失敗回数",
        "mfaRequired": "このカテゴリーで MFA を必須にする"
      },
      "placeholders": {
        "code": "例: CLINICAL"
      },
      "errors": {
        "nameRequired": "カテゴリー名は必須です",
        "codeRequired": "カテゴリーコードは必須です"
      },
      "submit": {
        "create": "カテゴリーを作成",
        "update": "カテゴリーを更新"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "カテゴリーを作成しました",
        "updatedSuccess": "カテゴリーを更新しました",
        "saveError": "カテゴリーの保存に失敗しました"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "なし",
      "basic": "基本",
      "full": "完全",
      "paranoid": "厳格"
    },
    "permissions": {
      "title": "デフォルト権限",
      "titleWithName": "デフォルト権限 — {{name}}",
      "subtitle": "このカテゴリーのロールは、明示的に拒否されない限りこれらの権限を継承します。",
      "invalidCategoryId": "カテゴリー ID が無効です。",
      "save": "デフォルト権限を保存",
      "cancel": "キャンセル",
      "toast": {
        "updatedSuccess": "デフォルト権限を更新しました",
        "saveError": "デフォルト権限の保存に失敗しました"
      }
    }
  },
  "permission": {
    "action": {
      "view": "閲覧",
      "viewSelf": "自身のみ閲覧",
      "viewRestricted": "制限付き閲覧",
      "read": "読取",
      "write": "書込",
      "create": "作成",
      "update": "更新",
      "modify": "変更",
      "delete": "削除",
      "merge": "統合",
      "discharge": "退院",
      "transfer": "転送",
      "approve": "承認",
      "cosign": "共同署名",
      "sign": "署名",
      "plan": "計画",
      "manage": "管理",
      "all": "すべて",
      "breakGlass": "緊急アクセス",
      "export": "エクスポート",
      "amend": "修正",
      "administer": "投与",
      "doubleCheck": "ダブルチェック",
      "reconcile": "照合",
      "verbalVerify": "口頭指示確認",
      "verify": "検証",
      "acknowledge": "確認",
      "prescribe": "処方",
      "dispense": "調剤",
      "cancel": "キャンセル",
      "users": "ユーザー",
      "roles": "ロール",
      "facilities": "施設",
      "system": "システム",
      "audit": "監査ログ"
    }
  },
  "access": {
    "title": "アクセス権限マトリックス",
    "subtitle": "ロール × 権限のグリッド",
    "searchPermission": "権限を検索…",
    "searchRole": "ロールを検索…",
    "categoryFilter": "カテゴリ",
    "legend": {
      "own": "直接",
      "inherited": "継承",
      "category": "カテゴリ",
      "denied": "拒否",
      "none": "なし"
    },
    "cellTooltip": {
      "hasOwn": "直接付与",
      "hasInherited": "親ロールから継承：{{source}}",
      "hasCategory": "カテゴリ経由で付与：{{source}}",
      "denied": "明示的に拒否",
      "none": "未付与"
    },
    "inheritedFrom": "{{source}} から継承",
    "bulkEdit": {
      "title": "一括編集",
      "applyTo": "選択項目に適用",
      "selectedPermissions": "{{count}} 件の権限",
      "selectedRoles": "{{count}} 個のロール",
      "actionGrant": "付与",
      "actionDeny": "拒否",
      "actionClear": "クリア",
      "save": "変更を保存",
      "cancel": "キャンセル"
    },
    "emptyRoles": "フィルター条件に一致するロールはありません。",
    "emptyPermissions": "フィルター条件に一致する権限はありません。",
    "loading": "アクセス権限マトリックスを読み込み中…",
    "permissionColumn": "権限",
    "rolePicker": {
      "trigger": "比較するロールを選択",
      "filterPlaceholder": "ロールを絞り込み…",
      "empty": "一致するロールはありません。",
      "groupAll": "すべて",
      "groupNone": "なし",
      "footerSummary": "{{count}} / {{total}} 件選択",
      "selectAll": "すべて選択",
      "clear": "クリア"
    },
    "empty": {
      "selectRolesPrompt": "比較するロールを 1 つ以上選択してください。",
      "selectAllRoles": "すべてのロールを選択",
      "noPermissions": "権限が見つかりません。"
    },
    "legendCategoryDefault": "カテゴリ既定",
    "legendNotGranted": "未付与",
    "page": {
      "title": "アクセス権限マトリックス",
      "subtitle": "ロール、権限、アクセスポリシーを表示・管理"
    },
    "tabs": {
      "matrix": "アクセス権限マトリックス",
      "roles": "ロール管理",
      "categories": "カテゴリ管理"
    },
    "roles": {
      "searchPlaceholder": "ロールまたは権限を検索...",
      "createButton": "ロールを作成",
      "columns": {
        "role": "ロール",
        "category": "カテゴリ",
        "parent": "親ロール",
        "permissions": "権限",
        "users": "ユーザー",
        "actions": "操作"
      },
      "systemBadge": "システム",
      "managePermissionsTitle": "権限を管理",
      "manageDeniedTitle": "拒否権限を管理",
      "deniedBadge": "拒否",
      "editTitle": "ロールを編集",
      "deleteTitle": "ロールを削除",
      "expandAria": "ロールを展開",
      "collapseAria": "ロールを折りたたむ",
      "effectivePermissions": "有効な権限",
      "noPermissionsAssigned": "権限が割り当てられていません。",
      "empty": "ロールが見つかりません。",
      "delete": {
        "title": "ロールを削除",
        "description": "ロール「{{name}}」を削除してもよろしいですか?この操作は取り消せません。",
        "confirm": "削除"
      },
      "toast": {
        "deleted": "ロールを削除しました",
        "deleteError": "ロールの削除に失敗しました"
      }
    },
    "categories": {
      "subtitle": "カテゴリはロールをグループ化し、共有ポリシー (MFA、セッション制限) を定義します。",
      "createButton": "カテゴリを作成",
      "requireMfa": "MFA を必須にする",
      "yes": "はい",
      "no": "いいえ",
      "sessionTimeout": "セッションタイムアウト",
      "sessionTimeoutMinutes": "{{count}} 分",
      "maxFailedLogins": "最大ログイン失敗回数",
      "manageDefaults": "既定の権限を管理",
      "editTitle": "編集",
      "editAria": "カテゴリを編集",
      "deleteTitle": "削除",
      "deleteAria": "カテゴリを削除",
      "empty": "カテゴリはまだ定義されていません。",
      "delete": {
        "title": "カテゴリを削除",
        "description": "カテゴリ「{{name}}」を削除してもよろしいですか?この操作は取り消せません。",
        "confirm": "削除"
      },
      "toast": {
        "deleted": "カテゴリを削除しました",
        "deleteError": "カテゴリの削除に失敗しました"
      }
    },
    "confirm": {
      "bulkApply": "{{count}} 件の変更を {{roleCount}} 個のロールに適用しますか?",
      "discardChanges": "未保存の変更を破棄しますか?"
    },
    "popover": {
      "grantTitle": "権限を付与",
      "denyTitle": "権限を拒否",
      "clearTitle": "権限をクリア",
      "grantNote": "この権限を付与すると、継承された拒否設定が上書きされます。",
      "denyNote": "この権限を拒否すると、継承された付与設定が上書きされます。",
      "clearNote": "クリアすると、継承された動作に戻ります。"
    },
    "toast": {
      "permissionGranted": "権限を付与しました",
      "permissionDenied": "権限を拒否しました",
      "permissionCleared": "権限をクリアしました",
      "bulkApplied": "一括変更を適用しました",
      "saveError": "変更の保存に失敗しました"
    }
  },
  "confirm": {
    "restartIntegration": "「{{name}}」を再起動しますか？新しい TLS 資材を読み込む間、アクティブな接続が一時的に切断されます。",
    "revokeFhirEndpoint": "「{{name}}」を失効させますか？このエンドポイントへの送信呼び出しは停止します。",
    "rotateSmartSecret": "「{{name}}」のクライアントシークレットをローテーションしますか？古いシークレットは直ちに無効になります。",
    "revokeSmartApp": "「{{name}}」を失効させますか？このアプリからの今後のトークン要求は失敗します。",
    "deactivateThirdPartyApp": "「{{name}}」を無効化しますか？"
  },
  "toast": {
    "tierCreated": "ティアを作成しました",
    "tierCloned": "ティアを複製しました",
    "tierDeleted": "ティアを削除しました",
    "tierStatusUpdated": "ステータスを更新しました",
    "tierFeaturesUpdated": "機能を更新しました",
    "tierLimitsUpdated": "上限を更新しました",
    "tierSaveError": "ティアの作成に失敗しました",
    "tierValidation": "名称とコードは必須です",
    "licenseKeyGenerated": "ライセンスキーを生成しました",
    "licenseKeyCopied": "ライセンスキーを生成し、クリップボードにコピーしました",
    "overridesSaved": "オーバーライドを保存しました",
    "pricingConfigSaved": "設定を保存しました",
    "pricingPriceUpdated": "価格を更新しました",
    "pricingRuleCreated": "料金ルールを作成しました",
    "addonUpdated": "アドオンを更新しました",
    "invalidNumber": "有効な数値を入力してください",
    "csvExported": "{{filename}} をエクスポートしました",
    "integrationUpdated": "連携を更新しました",
    "integrationAdded": "連携を追加しました",
    "integrationInvalidConfig": "設定が無効です — ホスト/ポートと TLS の項目を確認してください",
    "integrationDuplicateName": "同名の連携が既に存在します",
    "integrationSaveFailed": "連携の保存に失敗しました",
    "smartAppRegistered": "SMART アプリを登録しました",
    "smartAppRegisterFailed": "SMART アプリの登録に失敗しました",
    "smartAppUpdated": "SMART アプリを更新しました",
    "smartAppUpdateFailed": "SMART アプリの更新に失敗しました",
    "fhirEndpointUpdated": "エンドポイントを更新しました",
    "fhirEndpointRegistered": "エンドポイントを登録しました",
    "fhirEndpointInvalidConfig": "設定が無効です — base URL と auth フィールドを確認してください",
    "fhirEndpointDuplicateName": "その名前のエンドポイントはすでに存在します",
    "fhirEndpointSaveFailed": "エンドポイントの保存に失敗しました",
    "clientIdCopied": "Client ID をコピーしました",
    "clientSecretCopied": "Client secret をコピーしました",
    "statusRefreshed": "ステータスを更新しました",
    "connTestOk": "接続テストに成功しました",
    "connTestFailed": "接続テストに失敗しました - エンドポイント設定を確認してください",
    "serverRestarted": "サーバーを再起動しました — 新しい TLS 材料が有効です",
    "clientReconnected": "クライアントが再接続しました — 新しい TLS 材料が有効です",
    "notRunning": "未実行 — 設定を適用するにはサーバー/クライアントを起動してください",
    "restartFailed": "連携の再起動に失敗しました",
    "metadataOk": "/metadata 正常{{detail}}",
    "metadataFailed": "/metadata 失敗: {{error}}",
    "metadataProbeFailed": "/metadata の探索に失敗しました",
    "metadataUnknownError": "不明",
    "fhirRevoked": "FHIR エンドポイントを失効しました",
    "fhirRevokeFailed": "エンドポイントの失効に失敗しました",
    "smartRevoked": "SMART アプリを失効しました",
    "smartRevokeFailed": "SMART アプリの失効に失敗しました",
    "secretRotated": "クライアントシークレットをローテーションしました",
    "rotateSecretFailed": "シークレットのローテーションに失敗しました",
    "messageRequeued": "メッセージを再試行のため再キューしました",
    "messageRetryFailed": "再試行に失敗しました",
    "messageSkipped": "メッセージをスキップしました — キューが進みます",
    "messageSkipFailed": "スキップに失敗しました",
    "messageAbandoned": "メッセージを破棄しました",
    "messageAbandonFailed": "破棄に失敗しました",
    "messageResent": "メッセージを新規として再送信しました",
    "messageResendFailed": "再送信に失敗しました",
    "reasonRequired": "理由が必要です",
    "copiedToClipboard": "クリップボードにコピーしました",
    "thirdPartyAppCreated": "サードパーティアプリを作成しました",
    "thirdPartyAppUpdated": "サードパーティアプリを更新しました",
    "thirdPartyAppDeactivated": "サードパーティアプリを無効化しました",
    "thirdPartyAppLaunchUrl": "起動 URL を生成しました: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "施設を追加",
      "editTitle": "施設を編集",
      "fields": {
        "name": "名称",
        "code": "コード",
        "type": "種別",
        "address": "住所",
        "city": "市区町村",
        "stateProvince": "都道府県／州",
        "country": "国",
        "phone": "電話番号",
        "timeZone": "タイムゾーン",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "例：Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "IANA タイムゾーン名（例：Asia/Singapore）。患者統計、MAR、レポートで施設のローカル日付として使用されます。"
      },
      "options": {
        "otherIana": "その他（IANA）…",
        "useCuratedList": "推奨リストを使用"
      },
      "errors": {
        "nameMin": "施設名は{{min}}文字以上で入力してください",
        "codeFormat": "コードは大文字の英字と数字のみ使用できます",
        "typeRequired": "施設種別を入力してください",
        "countryRequired": "国を入力してください",
        "timeZoneRequired": "タイムゾーンを入力してください",
        "timeZoneInvalidIana": "サーバーがこのタイムゾーンを拒否しました。有効な IANA 名（例：Asia/Singapore）を使用してください。",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "作成",
        "update": "更新"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "施設を作成しました",
        "updatedSuccess": "施設を更新しました",
        "saveError": "施設の保存に失敗しました",
        "invalidTimeZone": "リクエストが無効です — タイムゾーンが有効な IANA 名（例：Asia/Singapore）であることをご確認ください。"
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "施設管理",
      "subtitle": "施設、部門、および（このツリーを通じて）物理ロケーション階層の概要。完全なロケーションツリー（建物 → 階 → ユニット → 部屋 → ベッド）を表示するには、<locationsLink>ロケーション</locationsLink>を参照してください。",
      "columns": {
        "name": "名称",
        "code": "コード",
        "type": "種別",
        "address": "住所",
        "phone": "電話",
        "depts": "部門数",
        "status": "ステータス",
        "actions": "操作"
      },
      "filter": {
        "search": "施設を検索..."
      },
      "actions": {
        "new": "施設を追加",
        "editTitle": "編集"
      },
      "expand": {
        "expand": "施設を展開",
        "collapse": "施設を折りたたむ"
      },
      "empty": {
        "noMatch": "検索条件に一致する施設が見つかりません。",
        "none": "施設がまだ登録されていません — 「施設を追加」をクリックして開始してください。"
      },
      "departments": {
        "title": "部門",
        "add": "部門を追加",
        "empty": "部門が設定されていません",
        "locationsCount": "{{count}} 件のロケーション",
        "editTitle": "部門を編集"
      },
      "locations": {
        "title": "ロケーション",
        "add": "追加",
        "empty": "この部門にはロケーションがありません。ロケーションツリー（建物 → 階 → ユニット → ベッド）は<locationsLink>ロケーション</locationsLink>で管理されます。"
      }
    },
    "type": {
      "generalHospital": "総合病院",
      "teachingHospital": "教育病院",
      "specialtyHospital": "専門病院",
      "communityHospital": "地域病院",
      "clinic": "診療所"
    },
    "status": {
      "active": "有効",
      "inactive": "無効"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "ヘルスシステムの追加",
      "editTitle": "ヘルスシステムの編集",
      "subtitle": "組織ツリーの最上位。一つ以上の施設の親組織です。",
      "sections": {
        "identity": "基本情報",
        "primaryContact": "主要連絡先",
        "address": "住所"
      },
      "fields": {
        "code": "コード",
        "name": "名称",
        "taxId": "税番号",
        "contactName": "氏名",
        "contactEmail": "メールアドレス",
        "contactPhone": "電話番号",
        "addressLine1": "住所1",
        "addressLine2": "住所2",
        "city": "市区町村",
        "stateProvince": "都道府県/州",
        "postalCode": "郵便番号",
        "country": "国/地域",
        "active": "有効 — チェックを外すと無効化されます。"
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "コードは作成後に変更できません。"
      },
      "errors": {
        "codeRequired": "コードを入力してください",
        "nameRequired": "名称を入力してください"
      },
      "submit": {
        "create": "ヘルスシステムを作成",
        "update": "変更を保存"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "ヘルスシステムを作成しました",
        "updatedSuccess": "ヘルスシステムを更新しました",
        "saveError": "ヘルスシステムの保存に失敗しました",
        "codeConflict": "このシステムコードはすでに存在します",
        "invalidData": "ヘルスシステムのデータが無効です"
      }
    },
    "list": {
      "title": "ヘルスシステム",
      "subtitle": "組織ツリーの最上位 — 一つ以上の施設を所有する企業／ヘルスシステムの親組織。初期設定後はほとんど変更されません。",
      "columns": {
        "name": "名称",
        "code": "コード",
        "contact": "連絡先",
        "location": "所在地",
        "facilities": "施設数",
        "status": "ステータス",
        "actions": "操作"
      },
      "filter": {
        "search": "名称またはコードで検索..."
      },
      "actions": {
        "new": "ヘルスシステムを追加",
        "editTitle": "編集"
      },
      "status": {
        "active": "有効",
        "inactive": "無効"
      },
      "empty": {
        "noMatch": "検索条件に一致するヘルスシステムが見つかりません。",
        "none": "ヘルスシステムがまだ登録されていません — 「ヘルスシステムを追加」をクリックして開始してください。"
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "ロケーションの追加",
      "editTitle": "ロケーションの編集",
      "subtitle": "物理ロケーション——建物、フロア、ユニット、病室、またはベッド。FHIR R4 Location 互換。上位ロケーションでネストして階層ツリーを構築します。",
      "sections": {
        "hierarchy": "階層",
        "identity": "識別",
        "classification": "分類",
        "physicalAttributes": "物理属性"
      },
      "fields": {
        "facility": "施設",
        "parentLocation": "上位ロケーション",
        "department": "部門（任意）",
        "code": "コード",
        "abbreviation": "略称",
        "name": "名称",
        "physicalType": "物理タイプ（FHIR）",
        "clinicalType": "臨床タイプ",
        "status": "ステータス（FHIR）",
        "operationalStatus": "運用ステータス（HL7 0116）",
        "building": "棟",
        "floor": "階",
        "wing": "ウィング",
        "roomNumber": "部屋番号",
        "bedIdentifier": "ベッド識別子",
        "capacity": "収容人数",
        "active": "有効（レガシーフラグ）"
      },
      "placeholders": {
        "facility": "施設を選択…",
        "parentNone": "なし（最上位）",
        "departmentNone": "なし",
        "code": "4W-12-A",
        "name": "4W-12 ベッド A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "FHIR LocationPhysicalType 値セット。",
        "clinicalType": "レガシー。service_type 導入時に廃止。"
      },
      "physicalAttributes": {
        "show": "表示 ▾",
        "hide": "非表示 ▴"
      },
      "errors": {
        "facilityRequired": "施設を選択してください",
        "codeRequired": "コードを入力してください",
        "nameRequired": "名称を入力してください"
      },
      "submit": {
        "create": "ロケーションを作成",
        "update": "変更を保存"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "ロケーションを作成しました",
        "updatedSuccess": "ロケーションを更新しました",
        "saveError": "ロケーションの保存に失敗しました",
        "codeConflict": "このロケーションコードはすでに存在します",
        "invalidData": "ロケーションのデータが無効です"
      }
    },
    "list": {
      "title": "ロケーション階層",
      "subtitle": "物理ツリー：建物 → フロア → ユニット → 部屋 → ベッド。FHIR LocationPhysicalType に準拠。ベッドのステータスバッジをクリックすると占有状況を切り替えます。施設と部門は <facilitiesLink>施設</facilitiesLink> で管理します。",
      "filter": {
        "search": "名称またはコードで検索...",
        "allFacilities": "すべての施設"
      },
      "actions": {
        "new": "ロケーションを追加",
        "addChildTitle": "子を追加",
        "editTitle": "編集"
      },
      "expand": {
        "expand": "ロケーションを展開",
        "collapse": "ロケーションを折りたたむ"
      },
      "bed": {
        "toggleTitle": "クリックで {{next}} に切り替え"
      },
      "empty": {
        "noMatch": "その検索に一致するロケーションはありません。",
        "none": "この施設にはまだロケーションがありません。"
      },
      "toast": {
        "bedStatusUpdated": "ベッドステータスを更新しました",
        "bedStatusError": "ベッドステータスの更新に失敗しました"
      }
    },
    "type": {
      "si": "サイト",
      "bu": "建物",
      "wi": "ウィング",
      "wa": "病棟",
      "lvl": "階",
      "co": "廊下",
      "ro": "病室",
      "bd": "ベッド",
      "ve": "仮想",
      "ho": "ハウス",
      "ca": "キャビネット",
      "rd": "道路",
      "area": "エリア",
      "jdn": "管轄区域"
    },
    "clinicalType": {
      "examRoom": "診察室",
      "inpatientBed": "入院ベッド",
      "procedureRoom": "処置室",
      "icu": "ICU",
      "ed": "救急",
      "or": "手術室",
      "virtual": "仮想"
    },
    "status": {
      "active": "有効",
      "suspended": "一時停止",
      "inactive": "無効",
      "op": {
        "O": "使用中",
        "U": "空き",
        "H": "清掃中",
        "K": "汚染",
        "I": "隔離",
        "C": "閉鎖"
      }
    },
    "capability": {
      "isolation": "隔離対応",
      "negativePressure": "陰圧",
      "bariatric": "肥満対応",
      "telemetry": "遠隔モニタリング対応",
      "icu": "ICUレベル"
    }
  },
  "department": {
    "form": {
      "addTitle": "部門の追加",
      "editTitle": "部門の編集",
      "subtitle": "施設内の組織単位。親部門を介して入れ子にできます（例：循環器科 → EP ラボ）。",
      "sections": {
        "department": "部門"
      },
      "fields": {
        "facility": "施設",
        "code": "コード",
        "abbreviation": "略称",
        "name": "名称",
        "type": "種類",
        "parentDepartment": "親部門",
        "costCenterCode": "コストセンターコード",
        "revenueDepartmentCode": "収益部門コード",
        "active": "有効 — チェックを外すと無効化されます。"
      },
      "placeholders": {
        "facility": "施設を選択…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "循環器科",
        "parentNone": "なし（最上位）",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "施設を選択してください",
        "codeRequired": "コードを入力してください",
        "nameRequired": "名称を入力してください"
      },
      "submit": {
        "create": "部門を作成",
        "update": "変更を保存"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "部門を作成しました",
        "updatedSuccess": "部門を更新しました",
        "saveError": "部門の保存に失敗しました",
        "codeConflict": "この部門コードはすでに存在します",
        "invalidData": "部門のデータが無効です"
      }
    },
    "serviceType": {
      "clinical": "臨床",
      "administrative": "管理",
      "support": "支援"
    },
    "status": {
      "active": "有効",
      "inactive": "無効"
    }
  },
  "provider": {
    "form": {
      "addTitle": "医療従事者を追加",
      "editTitle": "医療従事者を編集",
      "fields": {
        "fullName": "氏名",
        "npi": "NPI",
        "providerType": "医療者タイプ",
        "credentials": "資格",
        "specialty": "専門科",
        "email": "メールアドレス",
        "phone": "電話番号",
        "facilityAssignments": "施設配属",
        "status": "状態",
        "primaryFacility": "主施設",
        "loginAccount": "ログインアカウント"
      },
      "placeholders": {
        "specialty": "専門科を選択…",
        "credentials": "例：MD、FACC",
        "providerType": "医療者タイプを選択",
        "noLoginAccount": "ログインアカウントなし"
      },
      "submit": {
        "create": "作成",
        "update": "更新"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "医療従事者を追加しました",
        "updatedSuccess": "医療従事者を更新しました",
        "saveError": "医療従事者の保存に失敗しました"
      },
      "hints": {
        "loginAccount": "この臨床職員をログインアカウントに紐付けます。未設定の場合、副署名・薬剤師確認・重要結果の確認はいずれも拒否されます。"
      }
    },
    "list": {
      "title": "プロバイダー管理",
      "subtitle": "プロバイダー、資格情報、施設割り当てを管理します",
      "columns": {
        "name": "氏名",
        "npi": "NPI",
        "specialty": "専門科",
        "credentials": "資格",
        "facilities": "施設",
        "status": "ステータス",
        "actions": "操作"
      },
      "filter": {
        "search": "氏名・NPI・専門科で検索…",
        "allSpecialties": "すべての専門科",
        "allFacilities": "すべての施設",
        "allStatus": "すべてのステータス"
      },
      "actions": {
        "new": "プロバイダーを追加",
        "editTitle": "プロバイダーを編集",
        "scheduleTitle": "スケジュールテンプレート",
        "viewCredentials": "資格を表示"
      },
      "credentials": {
        "licenseLabel": "ライセンス",
        "none": "登録された資格情報はありません"
      },
      "empty": "プロバイダーが見つかりません",
      "pagination": {
        "summary": "{{from}}-{{to}} / {{total}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "前のページ",
        "next": "次のページ"
      },
      "toast": {
        "schedulePlaceholder": "スケジュールテンプレートのリンク（プレースホルダ）"
      },
      "noLogin": "ログインなし",
      "noLoginHint": "この医療者はログインアカウントが未連携のため、副署名・確認・承認ができません。"
    },
    "specialty": {
      "internalMedicine": "内科",
      "cardiology": "循環器内科",
      "emergencyMedicine": "救急科",
      "pediatrics": "小児科",
      "pathology": "病理科",
      "obstetricsGynecology": "産婦人科",
      "surgery": "外科",
      "orthopedics": "整形外科",
      "neurology": "神経内科",
      "psychiatry": "精神科",
      "radiology": "放射線科",
      "anesthesiology": "麻酔科",
      "oncology": "腫瘍科",
      "dermatology": "皮膚科",
      "ophthalmology": "眼科"
    },
    "status": {
      "active": "在籍",
      "inactive": "無効",
      "onLeave": "休職中"
    },
    "providerType": {
      "physician": "医師",
      "nurse": "看護師",
      "nursePractitioner": "ナースプラクティショナー",
      "physicianAssistant": "フィジシャンアシスタント",
      "pharmacist": "薬剤師",
      "therapist": "セラピスト",
      "technician": "技師",
      "other": "その他",
      "midwife": "助産師",
      "dentist": "歯科医師",
      "pharmacyTechnician": "薬剤助手",
      "careAssistant": "看護助手",
      "dietitian": "管理栄養士",
      "socialWorker": "医療ソーシャルワーカー",
      "traditionalMedicine": "伝統医学診療者"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "サービスラインを追加",
      "editTitle": "サービスラインを編集",
      "subtitle": "個別の診療サービスを統括する上位レベルの臨床グループ(循環器、腫瘍学など)。",
      "sections": {
        "serviceLine": "サービスライン"
      },
      "fields": {
        "healthSystem": "ヘルスシステム",
        "code": "コード",
        "name": "名称",
        "description": "説明",
        "active": "有効 — チェックを外すと論理無効化されます。"
      },
      "placeholders": {
        "healthSystem": "ヘルスシステムを選択…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "簡潔な説明 — 範囲、対象疾患など。"
      },
      "errors": {
        "healthSystemRequired": "ヘルスシステムは必須です",
        "codeRequired": "コードは必須です",
        "nameRequired": "名称は必須です"
      },
      "submit": {
        "create": "サービスラインを作成",
        "update": "変更を保存"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "サービスラインを追加しました",
        "updatedSuccess": "サービスラインを更新しました",
        "saveError": "サービスラインの保存に失敗しました",
        "codeConflict": "サービスラインコードはすでに存在します",
        "invalidData": "サービスラインのデータが無効です"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "臨床サービスを追加",
      "editTitle": "臨床サービスを編集",
      "subtitle": "個別の臨床サービス(循環器内科、EPラボなど)。任意でサービスラインの配下にグループ化し、請求およびディレクトリ出力のためにNUCC専門コードを付与できます。",
      "sections": {
        "clinicalService": "臨床サービス",
        "specialtyBilling": "専門 + 請求"
      },
      "fields": {
        "code": "コード",
        "name": "名称",
        "serviceLine": "サービスライン",
        "description": "説明",
        "specialtyCode": "NUCC専門コード",
        "specialtyDescription": "専門の説明",
        "revenueDepartmentCode": "収益部門コード",
        "active": "有効"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— なし —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "NUCC分類 — 医師ディレクトリおよび請求記載の根拠となります。"
      },
      "errors": {
        "codeRequired": "コードは必須です",
        "nameRequired": "名称は必須です"
      },
      "submit": {
        "create": "臨床サービスを作成",
        "update": "変更を保存"
      },
      "cancel": "キャンセル",
      "toast": {
        "createdSuccess": "臨床サービスを追加しました",
        "updatedSuccess": "臨床サービスを更新しました",
        "saveError": "臨床サービスの保存に失敗しました",
        "codeConflict": "臨床サービスコードはすでに存在します",
        "invalidData": "臨床サービスのデータが無効です"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "サービス ↔ 場所の割り当て",
    "subtitle": "どの診療サービスがどの物理的な場所で実施されるか(任意の曜日/時間帯ウィンドウと収容能力付き)。スケジューリングはこれを参照して空き枠を生成します。論理削除のみ — 割り当てを終了しても履歴はレポート用に保持されます。",
    "header": {
      "newAssignment": "割り当てを追加",
      "toggleCancel": "キャンセル"
    },
    "form": {
      "title": "新しい割り当て",
      "fields": {
        "service": "診療サービス",
        "location": "場所",
        "dayOfWeekPattern": "曜日パターン",
        "startTime": "開始時刻",
        "endTime": "終了時刻",
        "capacity": "収容率 %",
        "notes": "メモ",
        "isPrimary": "このサービスの主たる場所"
      },
      "placeholders": {
        "service": "サービスを選択…",
        "location": "場所を選択…",
        "dayOfWeekPattern": "1,3,5(月/水/金)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "カンマ区切りの ISO 曜日。空欄 = 毎日。"
      },
      "errors": {
        "serviceLocationRequired": "サービスと場所は必須です"
      },
      "create": "作成",
      "cancel": "キャンセル"
    },
    "filter": {
      "allFacilities": "すべての施設",
      "allServices": "すべてのサービス",
      "allLocations": "すべての場所",
      "allStatuses": "すべてのステータス",
      "searchService": "サービスを検索…",
      "searchLocation": "場所を検索…",
      "facility": "施設",
      "serviceLine": "サービスライン"
    },
    "columns": {
      "service": "サービス",
      "location": "場所",
      "facility": "施設",
      "when": "日時",
      "capacity": "収容能力",
      "effective": "有効期間",
      "status": "ステータス",
      "actions": "操作"
    },
    "status": {
      "active": "有効",
      "planned": "予定",
      "suspended": "停止中",
      "ended": "終了"
    },
    "dow": {
      "everyDay": "毎日",
      "monFri": "月〜金",
      "short": {
        "1": "月",
        "2": "火",
        "3": "水",
        "4": "木",
        "5": "金",
        "6": "土",
        "7": "日"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "主たる場所",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "主に設定",
      "unsetPrimary": "主を解除",
      "endAssignment": "割り当てを終了"
    },
    "bulkEdit": {
      "title": "一括編集",
      "applyTo": "選択対象に適用",
      "selectedServices": "{{count}} 件のサービス",
      "selectedLocations": "{{count}} 件の場所",
      "save": "変更を保存",
      "cancel": "キャンセル"
    },
    "confirm": {
      "endTitle": "割り当てを終了しますか?",
      "endDescription": "{{service}} → {{location}}。終了しても履歴は保持されますが、この組み合わせは有効なスケジューリングから除外されます。",
      "endConfirm": "割り当てを終了",
      "removeService": "{{location}} から {{service}} を削除しますか?",
      "makePrimary": "{{location}} を {{service}} の主たる場所にしますか?"
    },
    "toast": {
      "created": "割り当てを追加しました",
      "createError": "割り当ての作成に失敗しました",
      "ended": "割り当てを終了しました",
      "endError": "割り当ての終了に失敗しました",
      "primaryError": "主の切り替えに失敗しました",
      "updated": "割り当てを更新しました"
    },
    "empty": "これらのフィルターに一致する割り当てはありません。「割り当てを追加」をクリックして追加してください。"
  },
  "integration": {
    "list": {
      "title": "連携管理",
      "subtitle": "HL7、FHIR、サードパーティシステム連携",
      "refresh": "更新",
      "addEndpoint": "エンドポイントを追加",
      "searchPlaceholder": "連携を検索…",
      "tabs": {
        "endpoints": "エンドポイント",
        "messageLog": "メッセージログ",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "エンドポイント総数",
        "connected": "接続済み",
        "errors": "エラー",
        "totalMessages": "メッセージ総数"
      }
    },
    "columns": {
      "status": "ステータス",
      "name": "名称",
      "type": "種別",
      "direction": "方向",
      "url": "URL",
      "tls": "TLS",
      "auth": "認証",
      "lastMessage": "最終メッセージ",
      "messages": "メッセージ数",
      "errors": "エラー数",
      "backlog": "バックログ",
      "health": "ヘルス",
      "actions": "操作",
      "backlogTitle": "未送信のアウトバウンドメッセージ + 最も古い保留メッセージの経過時間",
      "healthTitle": "ヘルス状態 — 失敗メッセージでキューがブロックされている場合は赤"
    },
    "badge": {
      "tlsCerts": "証明書：{{cert}}、鍵：{{key}}、CA：{{ca}}",
      "yes": "あり",
      "no": "なし",
      "basicTitle": "basic（{{username}}）",
      "bearerStored": "Bearer トークン保存済み",
      "bearerNoToken": "bearer（トークン未設定）",
      "mtlsCert": "mTLS クライアント証明書",
      "awaitingAck": "{{n}} 件が ACK 待ち",
      "oldest": "最古 {{age}}",
      "never": "なし",
      "blocked": "ブロック",
      "waiting": "待機中",
      "ok": "正常",
      "blockedTitle": "失敗したメッセージがこの連携のキューをブロックしています。クリックして絞り込みログを開きます。",
      "waitingTitle": "パートナーからの拡張モードアプリ ACK を待っているメッセージです。クリックして絞り込みログを開きます。",
      "okTitle": "すべて正常 — クリックしてこの連携のメッセージログを開きます。",
      "receives": "受信"
    },
    "action": {
      "testConnection": "接続テスト",
      "restartTls": "再起動 — 更新された TLS を適用",
      "investigate": "スループット、レイテンシ、最近の失敗",
      "edit": "編集"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "最近 50 件のメッセージ",
      "columns": {
        "time": "時刻",
        "id": "ID",
        "direction": "方向",
        "type": "種別",
        "source": "ソース",
        "summary": "概要",
        "status": "ステータス"
      },
      "dir": {
        "in": "入",
        "out": "出"
      }
    },
    "fhir": {
      "serverStatusHeader": "FHIR R4 サーバーステータス",
      "serverOnline": "サーバーオンライン",
      "supportedResources": "対応リソース",
      "version": "バージョン",
      "externalHeader": "外部 FHIR エンドポイント",
      "registerEndpoint": "エンドポイントを登録",
      "columns": {
        "name": "名称",
        "baseUrl": "ベース URL",
        "auth": "認証",
        "status": "ステータス",
        "lastChecked": "最終確認",
        "actions": "操作"
      },
      "emptyEndpoints": "外部 FHIR エンドポイントはまだ登録されていません。",
      "revoked": "失効",
      "statusOk": "正常",
      "statusError": "エラー",
      "testMetadata": "/metadata をテスト",
      "edit": "編集",
      "revoke": "失効"
    },
    "smart": {
      "header": "登録済み SMART アプリ",
      "registerApp": "アプリを登録",
      "columns": {
        "appName": "アプリ名",
        "clientId": "Client ID",
        "scopes": "スコープ",
        "status": "ステータス",
        "lastModified": "最終更新",
        "actions": "操作"
      },
      "emptyApps": "SMART アプリはまだ登録されていません。",
      "edit": "編集",
      "rotateSecret": "クライアントシークレットをローテーション",
      "revoke": "失効"
    },
    "secretModal": {
      "title": "この client secret を今すぐ保存してください",
      "body": "このシークレットは一度だけ表示されます。紛失した場合は、シークレットをローテーションして新しいものを発行してください。",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Client ID をコピー",
      "copyClientSecret": "Client Secret をコピー",
      "saved": "保存しました"
    },
    "drawer": {
      "header": "連携 #{{id}}",
      "refresh": "更新",
      "close": "閉じる",
      "queueBlocked": "キューがブロックされています",
      "queueBlockedBody": "失敗したメッセージがこの連携の送信を停止しています。後続のメッセージはオペレーターが対応するまで待機します。",
      "investigate": "調査",
      "tiles": {
        "backlog": "バックログ",
        "success24h": "成功率 24h",
        "avgLatency24h": "平均レイテンシ 24h",
        "awaitingAck": "app-ACK 待ち"
      },
      "charts": {
        "throughput": "スループット（24h）",
        "throughputSub": "1時間単位。積み上げ：送信の完了 + 失敗。受信は副軸に表示。",
        "successRate": "成功率（24h）",
        "successRateSub": "バケットごと：完了 /（完了 + 失敗）。空白はアイドルのバケットです。",
        "ackLatency": "ACK レイテンシ（24h）",
        "ackLatencySub": "送信から ACK 受信までの時間。avg は実線、p95 は破線。"
      },
      "series": {
        "outCompleted": "送信 · 完了",
        "outFailed": "送信 · 失敗",
        "inReceived": "受信 · 受領",
        "successPct": "成功率 %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "最近の失敗",
      "viewAll": "すべて表示 →",
      "noFailures": "最近のウィンドウに失敗メッセージはありません。🎉"
    }
  },
  "integrationStatus": {
    "connected": "接続済み",
    "disconnected": "切断",
    "error": "エラー"
  },
  "integrationDirection": {
    "server": "サーバー",
    "client": "クライアント"
  },
  "messageStatus": {
    "sent": "送信済み",
    "received": "受信済み",
    "error": "エラー",
    "acknowledged": "確認済み"
  },
  "smartAppStatus": {
    "active": "有効",
    "revoked": "失効"
  },
  "interfaceMessageStatus": {
    "pending": "保留中",
    "processing": "処理中",
    "completed": "完了",
    "received": "受信済み",
    "processed": "処理済み",
    "failed": "失敗",
    "error": "エラー",
    "rejected": "拒否",
    "deadLetter": "デッドレター",
    "skipped": "スキップ",
    "awaitingAppAck": "アプリ ACK 待ち"
  },
  "interfaceDirection": {
    "in": "受信",
    "out": "送信"
  },
  "attemptOutcome": {
    "sent": "送信済み",
    "appNak": "アプリ NAK",
    "timeout": "タイムアウト",
    "networkError": "ネットワークエラー"
  },
  "fhirEndpoint": {
    "titleEdit": "FHIR エンドポイントの編集",
    "titleRegister": "FHIR エンドポイントの登録",
    "subtitle": "ゲートウェイがアウトバウンドで通信する外部 FHIR R4 パートナー。統合一覧の Test Connection ボタンは、設定された auth + TLS で <code>/metadata</code> をプローブします。",
    "back": "戻る",
    "cancel": "キャンセル",
    "storedBlank": "保存済み — 維持するには空欄のままにします",
    "save": {
      "changes": "変更を保存",
      "register": "エンドポイントを登録"
    },
    "section": {
      "basics": "基本",
      "auth": "認証",
      "tls": "TLS"
    },
    "fields": {
      "name": "名前",
      "baseUrl": "Base URL",
      "description": "説明",
      "active": "有効 — ソフト失効するにはチェックを外します。",
      "method": "方式",
      "username": "ユーザー名",
      "password": "パスワード",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "https:// が必須です（開発用に http://localhost も受け付けます）。Test 時に末尾の /metadata が自動的に付加されます。",
      "oauth2": "OAuth2 トークン取得は管理側で配線済みです。ランタイムフェッチャーは後続で対応します。今は値を入力し、残りの設定を確認するために Test を実行してください。",
      "tls": "パートナーのサーバー証明書をピン留めするにはルート CA を貼り付けるか、mTLS 用に client cert + key を貼り付けてください。よく知られた CA の場合、CA だけでシステムのルートストアと連携します。"
    },
    "option": {
      "method": {
        "none": "なし",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — ほとんどのパートナーでは任意",
      "clientCertRequired": "Client certificate (PEM) — 必須",
      "clientCertMtls": "Client certificate (PEM) — mTLS 用",
      "clientKeyRequired": "Client private key (PEM) — 必須",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "名前は必須です",
      "baseUrlRequired": "Base URL は必須です",
      "baseUrlInvalid": "ベースURLは有効なhttp(s) URLである必要があります",
      "basicUsername": "Basic auth にはユーザー名が必要です",
      "basicPassword": "Basic auth にはパスワードが必要です",
      "bearerToken": "Bearer auth には token が必要です",
      "clientCertKey": "Client-certificate auth には cert + key が必要です"
    }
  },
  "smartApp": {
    "titleEdit": "SMART アプリを編集",
    "titleRegister": "SMART アプリを登録",
    "subtitle": "SMART on FHIR クライアント登録。Client ID は自動生成されます。client secret は作成またはローテーション後に一度だけ表示されます。",
    "back": "戻る",
    "cancel": "キャンセル",
    "save": "変更を保存",
    "register": "登録",
    "fields": {
      "appName": "アプリ名",
      "redirectUris": "リダイレクト URI",
      "scopes": "スコープ",
      "launchUrl": "起動 URL",
      "logoUrl": "ロゴ URL",
      "active": "有効 — チェックを外すとこのアプリをソフト失効します。"
    },
    "placeholder": {
      "appName": "マイ EHR ランチャー"
    },
    "helper": {
      "redirectUris": "1 行に 1 つの URI。https:// が必要です（開発用に http://localhost も使用できます）。"
    },
    "secretModal": {
      "title": "この client secret を今すぐ保存してください",
      "body": "このシークレットは一度だけ表示されます。紛失した場合は、シークレットをローテーションして新しいものを発行してください。",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Client ID をコピー",
      "copyClientSecret": "Client Secret をコピー",
      "saved": "保存しました"
    },
    "validation": {
      "nameRequired": "名前は必須です",
      "redirectUriRequired": "リダイレクト URI を少なくとも 1 つ指定してください",
      "scopeRequired": "スコープを少なくとも 1 つ指定してください"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "インターフェイスメッセージログ",
      "subtitle": "すべての有効な統合における受信・送信 HL7 メッセージ。",
      "refresh": "更新",
      "loading": "メッセージを読み込み中…",
      "empty": "現在のフィルターに一致するメッセージはありません。",
      "pagination": "{{total}} 件のメッセージ • {{pages}} ページ中 {{page}} ページ",
      "prev": "前へ",
      "next": "次へ",
      "archived": "(アーカイブ)"
    },
    "relative": {
      "secondsAgo": "{{n}} 秒前",
      "minutesAgo": "{{n}} 分前",
      "hoursAgo": "{{n}} 時間前"
    },
    "filter": {
      "header": "フィルター",
      "direction": "方向",
      "status": "ステータス",
      "messageType": "メッセージタイプ",
      "msh10": "MSH-10 を含む",
      "integrationId": "統合 ID",
      "includeArchive": "アーカイブを含める",
      "clear": "フィルターをクリア",
      "any": "すべて",
      "messageTypePlaceholder": "例: ADT^A01",
      "controlIdPlaceholder": "コントロール ID"
    },
    "columns": {
      "id": "ID",
      "dir": "方向",
      "integ": "統合",
      "type": "タイプ",
      "msh10": "MSH-10",
      "status": "ステータス",
      "ack": "ACK",
      "attempts": "試行回数",
      "when": "日時"
    },
    "detail": {
      "eyebrow": "{{direction}}メッセージ",
      "close": "閉じる",
      "loading": "読み込み中…",
      "tabs": {
        "overview": "概要",
        "rawHl7": "生 HL7",
        "attempts": "試行"
      },
      "operatorActions": "オペレーター操作",
      "retry": "再試行",
      "skip": "スキップ",
      "abandon": "破棄",
      "resendAsNew": "新規として再送信",
      "skipReason": "スキップ理由",
      "abandonReason": "破棄理由",
      "actionsHelper": "操作はユーザー ID と理由とともに監査されます。スキップと破棄には理由が必要です。",
      "overview": {
        "direction": "方向",
        "integration": "統合",
        "type": "タイプ",
        "msh10": "MSH-10",
        "status": "ステータス",
        "ackCode": "ACK コード",
        "attempts": "試行",
        "created": "作成日時",
        "ackReceived": "ACK 受信",
        "nextRetry": "次回再試行",
        "ackText": "ACK テキスト",
        "lastError": "最後のエラー",
        "sourceEventId": "ソースイベント ID"
      },
      "rawViewer": {
        "permissionDenied": "復号された生 HL7 には <code>INTERFACE_OPERATE</code> 権限が必要です。",
        "notAvailable": "このメッセージには利用可能な生ペイロードがありません。",
        "bytes": "{{bytes}} バイト",
        "copy": "コピー"
      },
      "attempts": {
        "inboundInfo": "試行履歴は送信メッセージのみ追跡されます。受信メッセージは MSH-10 ごとに一度処理され、再送信は新しい試行なしでキャッシュされた ACK を返します。",
        "totalAttempts": "試行回数の合計",
        "nextAt": "（次回 {{time}}）",
        "refresh": "更新",
        "loading": "試行を読み込み中…",
        "error": "試行の読み込みに失敗しました。",
        "empty": "まだ試行は記録されていません。ワーカーは送信ごとに 1 行を書き込みます。最初のクレーム後にこのリストが埋まります。",
        "columns": {
          "when": "日時",
          "outcome": "結果",
          "ack": "ACK",
          "duration": "所要時間",
          "detail": "詳細"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "サードパーティアプリケーション",
      "subtitle": "患者コンテキストとともに VynaEMR から起動できる外部アプリケーションを設定します",
      "addApp": "アプリケーションを追加",
      "searchPlaceholder": "名前、コード、カテゴリでアプリを検索...",
      "emptyTitle": "設定されたアプリケーションはありません",
      "emptyBody": "PACS ビューア、検査ポータル、薬局システムなどの外部アプリケーションを追加します。",
      "columns": {
        "application": "アプリケーション",
        "category": "カテゴリ",
        "url": "URL",
        "security": "セキュリティ",
        "display": "表示",
        "status": "ステータス",
        "actions": "操作"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "JWT 署名済み",
      "hmac": "HMAC",
      "hmacSigned": "HMAC 署名済み",
      "none": "なし",
      "chart": "チャート",
      "sidebar": "サイドバー",
      "active": "有効",
      "inactive": "無効"
    },
    "action": {
      "testLaunch": "テスト起動",
      "edit": "編集",
      "deactivate": "無効化"
    },
    "form": {
      "titleEdit": "アプリケーションを編集",
      "titleNew": "新規アプリケーション",
      "fields": {
        "appCode": "アプリコード",
        "appName": "アプリ名",
        "category": "カテゴリ",
        "baseUrl": "ベース URL",
        "launchMethod": "起動方法",
        "paramMappings": "パラメータマッピング",
        "enableJwt": "JWT トークン署名を有効化",
        "sharedSecret": "共有シークレット（JWT 署名キー）",
        "enableHmac": "URL 署名を有効化（HMAC）",
        "hmacKey": "HMAC キー",
        "requiredPermission": "必要な権限",
        "displayOrder": "表示順",
        "showInChart": "チャートに表示",
        "showInSidebar": "サイドバーに表示"
      },
      "placeholder": {
        "appCode": "例: pacs_viewer",
        "appName": "例: PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "URL パラメータ名",
        "unchanged": "（変更なし）",
        "sharedSecret": "共有シークレットを入力",
        "hmacKey": "HMAC キーを入力",
        "requiredPermission": "例: RESULT_VIEW（空欄 = すべてのユーザー）"
      },
      "addParameter": "パラメータを追加",
      "cancel": "キャンセル",
      "submitUpdate": "アプリケーションを更新",
      "submitCreate": "アプリケーションを作成"
    },
    "paramSource": {
      "patientMrn": "患者 MRN",
      "patientName": "患者氏名",
      "patientDob": "患者 DOB",
      "encounterId": "受診 ID",
      "encounterNumber": "受診番号",
      "orderNumber": "オーダー番号",
      "userName": "現在のユーザー名",
      "userId": "現在のユーザー ID",
      "timestamp": "現在のタイムスタンプ"
    },
    "launch": "{{name}} を起動"
  },
  "integrationForm": {
    "titleEdit": "連携を編集",
    "titleAdd": "連携を追加",
    "subtitle": "VynaHL7 を基盤とする MLLP および HL7-over-HTTP インターフェース。証明書素材は連携レコードに保存され、ローテーションはサーバーまたはクライアントの次回再起動時に有効になります。",
    "back": "戻る",
    "cancel": "キャンセル",
    "saveChanges": "変更を保存",
    "addIntegration": "連携を追加",
    "storedBlank": "保存済み — 保持する場合は空欄のまま",
    "selectSibling": "— 同階層の連携を選択 —",
    "section": {
      "basics": "基本",
      "connection": "接続",
      "tls": "TLS / mTLS",
      "auth": "認証",
      "ackDelivery": "確認応答と配信",
      "outboundRouting": "送信ルーティング",
      "inboundTrust": "受信の信頼レベル"
    },
    "fields": {
      "name": "名前",
      "type": "種別",
      "direction": "方向",
      "description": "説明",
      "active": "有効 — チェックを外すとこのインターフェースをソフト無効化します。",
      "host": "ホスト",
      "port": "ポート",
      "enableTls": "TLS を有効化 — 使用するのは",
      "serverCert": "サーバー証明書（PEM）",
      "clientCert": "クライアント証明書（PEM）— mTLS では任意",
      "serverKey": "サーバー秘密鍵（PEM）",
      "clientKey": "クライアント秘密鍵（PEM）",
      "serverCa": "クライアント CA トラストストア（PEM）— mTLS 用",
      "clientCa": "サーバー CA トラストストア（PEM）— 任意、システムルートにフォールバック",
      "method": "方式",
      "username": "ユーザー名",
      "password": "パスワード",
      "bearerToken": "Bearer トークン",
      "inboundAck": "受信 ACK ポリシー",
      "outboundAck": "送信 ACK ポリシー",
      "processingTimeout": "処理タイムアウト（ミリ秒）",
      "pendingAckTtl": "保留中 ACK TTL（秒）",
      "networkRetry": "ネットワーク再試行上限",
      "appNakRetry": "アプリ NAK 再試行上限",
      "reverseIntegration": "逆方向チャネル連携",
      "outboundTypes": "受信するメッセージタイプ",
      "outboundEvents": "イベント単位の購読",
      "receivingApplication": "受信アプリケーション (MSH-5)",
      "receivingFacility": "受信施設 (MSH-6)",
      "inboundTrustProfile": "この連携先に許可すること"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "このインターフェースに関する短いメモ — 担当者、目的、メッセージ種別など。",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "バインドアドレス。すべてのインターフェースで待ち受けるには 0.0.0.0 を使用します。",
      "hostClient": "このクライアントが接続するリモートホスト。",
      "tlsHandshake": "をハンドシェイクに使用します。",
      "authClientCert": "クライアント証明書／鍵は上の TLS セクションから取得されます。",
      "authNone": "HTTP 認証ヘッダーは付加されません。",
      "authRs7": "{{call}} がこれをすべての送信リクエストに組み込みます。",
      "ackDefaults": "ゲートウェイが受信 HL7 メッセージをどう ACK し、送信時の応答 ACK をどう解釈するかを制御します。デフォルト値",
      "ackDefaultsTail": "は 0.19.0 以前の動作に一致します — 連携先ごとに必要に応じて変更してください。",
      "processingTimeout": "同期アプリ ACK のインライン処理の上限。タイムアウト → AE + バックグラウンドキュー再試行。",
      "pendingAckTtl": "拡張モードのアプリ ACK 待機時間。これを超えるとスイーパーがタイムアウト処理します。",
      "networkRetry": "キューがブロックされる前の転送エラー再試行回数。",
      "appNakRetry": "AE/AR/CE/CR の再試行回数 — 同じペイロードは再試行で成功することがまれなため通常 2〜3 回。",
      "reverse": "拡張モードでは、連携先の逆方向エンドポイントを指す同階層の連携を介して実際のアプリ ACK を配信します。まず同階層を別の連携レコードとして作成し、ここでリンクしてください。",
      "outboundRouting": "この連携先が受け取るメッセージ。何も選択しない場合、このインターフェースは送信先ではなく、メッセージは一切送信されません。",
      "outboundEvents": "任意。カンマ区切り。タイプ全体より細かい指定で、特定のイベントだけを必要とする連携先に使います。",
      "receivingDefaults": "MSH-5 と MSH-6 は、ここへ送信する各メッセージの受信者を示します。空欄の場合はインターフェース名を使用します。",
      "inboundTrust": "この連携先が患者の同一性について何を主張できるか。認証は「誰が接続しているか」を示し、この設定は「何を伝えることを許すか」を示します。この接続先が本当に登録マスターでない限り、配備既定値のままにしてください。"
    },
    "option": {
      "type": {
        "mllp": "MLLP（TCP 上の HL7 v2）",
        "hoh": "HoH（HTTPS 上の HL7）",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "クライアント（送信）",
        "server": "サーバー（受信）"
      },
      "method": {
        "none": "なし",
        "basic": "HTTP Basic",
        "bearer": "Bearer トークン",
        "clientCert": "クライアント証明書（mTLS）"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "即座に AA（現在のデフォルト）",
        "honorMsh16": "メッセージごとに MSH-15/16 を読み取る",
        "forceSync": "インライン処理し、結果に応じて AA/AE/AR",
        "forceEnhanced": "今すぐ CA + 逆方向チャネル経由のアプリ ACK"
      },
      "outbound": {
        "fireAndForget": "送信したら待たない（現在のデフォルト）",
        "expectSync": "MSH-16=AL を設定し、AE/AR で再試行",
        "expectEnhanced": "CA を待ち、続くアプリ ACK を待つ"
      }
    },
    "validation": {
      "nameRequired": "名前は必須です",
      "hostRequired": "ホストは必須です",
      "mllpPort": "MLLP 連携にはポートが必要です",
      "portNumber": "ポートは数値でなければなりません",
      "tlsServerCertKey": "TLS サーバーには証明書と鍵の両方が必要です",
      "basicUsername": "Basic 認証にはユーザー名が必要です",
      "basicPassword": "Basic 認証にはパスワードが必要です",
      "bearerToken": "Bearer 認証にはトークンが必要です",
      "enhancedReverse": "拡張 ACK モードには逆方向連携が必要です — 下から選択してください。",
      "outboundEvent": "「{{value}}」は本システムが送信するメッセージではありません — ADT のようなタイプ、または ADT^A01 のようなイベントを指定してください。"
    },
    "trust": {
      "useDeploymentDefault": "配備の既定値を使用",
      "observer": "オブザーバー — 患者を作成も変更もしない",
      "demographics": "患者基本情報 — 既存患者の訂正が可能（死亡通知を含む）。作成は不可",
      "registration": "登録 — 患者の作成とカルテ統合も可能"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "画像診断",
    "laboratory": "検査",
    "pharmacy": "薬局",
    "specialty": "専門科",
    "portal": "ポータル",
    "billing": "請求",
    "other": "その他"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "リダイレクト",
    "popup": "ポップアップウィンドウ",
    "iframe": "iframe",
    "newTab": "新しいタブ"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "CDS ルールを編集",
      "titleCreate": "CDS ルールを作成",
      "ruleName": "ルール名",
      "ruleType": "ルール種別",
      "selectPlaceholder": "選択してください…",
      "severity": "重大度",
      "triggerEvent": "トリガーイベント",
      "actionType": "アクションタイプ",
      "description": "説明",
      "active": "有効",
      "cancel": "キャンセル",
      "submitUpdate": "ルールを更新",
      "submitCreate": "ルールを作成",
      "createdOk": "ルールを作成しました",
      "createFailed": "ルールの作成に失敗しました",
      "updatedOk": "ルールを更新しました",
      "updateFailed": "ルールの更新に失敗しました",
      "validation": {
        "nameRequired": "ルール名は必須です",
        "typeRequired": "ルール種別は必須です",
        "descriptionRequired": "説明は必須です",
        "triggerRequired": "トリガーイベントは必須です",
        "actionRequired": "アクションタイプは必須です"
      }
    },
    "list": {
      "title": "CDS ルール",
      "subtitle": "臨床意思決定支援ルールを管理します",
      "addRule": "ルールを追加",
      "loading": "CDS ルールを読み込んでいます…",
      "loadError": "CDS ルールの読み込みに失敗しました。",
      "empty": "CDS ルールが設定されていません。",
      "columns": {
        "ruleName": "ルール名",
        "type": "種類",
        "severity": "重大度",
        "description": "説明",
        "status": "状態",
        "actions": "操作"
      },
      "toggleActive": "クリックして無効化",
      "toggleInactive": "クリックして有効化",
      "active": "有効",
      "inactive": "無効",
      "editRule": "ルールを編集",
      "statusUpdated": "ルールの状態を更新しました",
      "statusUpdateFailed": "ルールの状態の更新に失敗しました"
    }
  },
  "cdsSeverity": {
    "info": "情報",
    "warning": "警告",
    "critical": "重大"
  },
  "cdsTriggerEvent": {
    "orderSign": "オーダー署名",
    "orderSelect": "オーダー選択",
    "patientView": "患者参照",
    "medicationPrescribe": "薬剤処方",
    "resultReceived": "結果受信",
    "patientAdmit": "患者入院"
  },
  "cdsActionType": {
    "alert": "アラート",
    "warning": "警告",
    "hardStop": "強制停止",
    "suggestion": "提案",
    "notification": "通知"
  },
  "cdsRuleType": {
    "drugInteraction": "薬物相互作用",
    "drugAllergy": "薬物アレルギー",
    "duplicateOrder": "重複オーダー",
    "custom": "カスタム",
    "clinicalAlert": "臨床アラート",
    "sepsisScreen": "敗血症スクリーニング"
  },
  "system": {
    "title": "システム構成",
    "subtitle": "アプリケーション設定、セキュリティ、システムの稼働状況",
    "restartServices": "サービスの再起動",
    "restartToast": "サービスの再起動（プレースホルダー - 確認が必要です）",
    "loadError": "システム構成の読み込みに失敗しました",
    "section": {
      "systemInfo": "システム情報",
      "systemInfoDesc": "バージョン、稼働時間、サービスの稼働状況",
      "general": "一般設定",
      "generalDesc": "アプリケーション名、タイムゾーン、ブランディング",
      "security": "セキュリティ設定",
      "securityDesc": "パスワードポリシー、MFA、セッション管理",
      "notifications": "通知設定",
      "notificationsDesc": "メールおよびSMSゲートウェイの設定",
      "integration": "連携デフォルト",
      "integrationDesc": "MLLP、FHIR、HL7 のデフォルト設定",
      "featureFlags": "機能フラグ",
      "featureFlagsDesc": "システム機能の有効化または無効化",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "バージョン",
      "uptime": "稼働時間",
      "database": "データベース",
      "redis": "Redis",
      "microservices": "マイクロサービス",
      "conn": "接続"
    },
    "uptime": {
      "running": "稼働中",
      "unknown": "不明",
      "up": "稼働中"
    },
    "subsection": {
      "passwordPolicy": "パスワードポリシー",
      "mfa": "多要素認証",
      "sessionLockout": "セッションとロックアウト",
      "emailConfig": "メール設定",
      "smsGateway": "SMSゲートウェイ",
      "mllpDefaults": "MLLP デフォルト",
      "fhirConfig": "FHIR 設定",
      "hl7Encoding": "HL7 v2 エンコーディング"
    },
    "fields": {
      "appName": "アプリケーション名",
      "timezone": "タイムゾーン",
      "dateFormat": "日付形式",
      "supportEmail": "サポートメール",
      "logoUrl": "ロゴURL",
      "maintenanceMode": "メンテナンスモード（ユーザーアクセスを無効化）",
      "upload": "アップロード",
      "minPasswordLength": "最小パスワード長",
      "passwordExpiry": "パスワード有効期限（日）",
      "requireUppercase": "大文字を必須",
      "requireNumbers": "数字を必須",
      "requireSpecialChars": "特殊文字を必須",
      "enableMfa": "MFAを有効化",
      "mfaMethod": "MFA方式",
      "sessionTimeout": "セッションタイムアウト（分）",
      "maxLoginAttempts": "最大ログイン試行回数",
      "lockoutDuration": "ロックアウト時間（分）",
      "smtpHost": "SMTPホスト",
      "smtpPort": "SMTPポート",
      "smtpUser": "SMTPユーザー",
      "fromEmail": "送信元メール",
      "useTls": "TLSを使用",
      "enabled": "有効",
      "provider": "プロバイダー",
      "fromNumber": "送信元番号",
      "defaultPort": "デフォルトポート",
      "timeoutSeconds": "タイムアウト（秒）",
      "retryCount": "リトライ回数",
      "fhirBaseUrl": "FHIR ベース URL",
      "authMethod": "認証方式",
      "fieldSeparator": "フィールド区切り文字",
      "encodingChars": "エンコーディング文字",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "アジア/シンガポール（UTC+8）",
        "hongKong": "アジア/香港（UTC+8）",
        "kualaLumpur": "アジア/クアラルンプール（UTC+8）",
        "bangkok": "アジア/バンコク（UTC+7）",
        "tokyo": "アジア/東京（UTC+9）",
        "kolkata": "アジア/コルカタ（UTC+5:30）",
        "sydney": "オーストラリア/シドニー（UTC+11）"
      },
      "mfa": {
        "totp": "TOTP（認証アプリ）",
        "sms": "SMS",
        "email": "メール"
      },
      "fhirAuth": {
        "none": "なし",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "一般設定を保存",
      "security": "セキュリティ設定を保存",
      "notifications": "通知設定を保存",
      "integration": "連携設定を保存",
      "features": "機能フラグを保存",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "一般",
      "security": "セキュリティ",
      "notifications": "通知",
      "integration": "連携",
      "features": "機能フラグ",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "ロゴをアップロード（プレースホルダー）",
      "saved": "{{section}}設定を保存しました",
      "saveFailed": "設定の保存に失敗しました"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "患者統合",
        "description": "患者の統合/統合解除機能を有効化"
      },
      "breakGlass": {
        "label": "緊急アクセス",
        "description": "制限レコードへの緊急オーバーライドを許可"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "外部システム向けに FHIR R4 エンドポイントを公開"
      },
      "smartApps": {
        "label": "SMART on FHIR アプリ",
        "description": "サードパーティ SMART アプリの接続を許可"
      },
      "clinicalDecisionSupport": {
        "label": "臨床意思決定支援",
        "description": "オーダーエントリーで CDS フックを有効化"
      },
      "telemedicine": {
        "label": "遠隔医療モジュール",
        "description": "ビデオ診療と遠隔モニタリング"
      },
      "patientPortal": {
        "label": "患者ポータル",
        "description": "患者向けの記録・予約ポータル"
      },
      "analyticsDashboard": {
        "label": "分析ダッシュボード",
        "description": "高度な分析・レポートダッシュボード"
      },
      "medicationBarcode": {
        "label": "薬剤バーコードスキャン",
        "description": "薬剤投与のバーコード照合"
      },
      "autoCoding": {
        "label": "自動コーディング（ICD/CPT）",
        "description": "AI 支援による診断・処置コーディング"
      }
    }
  },
  "audit": {
    "title": "監査ログ",
    "subtitle": "詳細な変更追跡を含むシステム操作ログ",
    "exportCsv": "CSV エクスポート",
    "exportToast": "{{count}} 件の監査エントリを CSV としてエクスポート中（プレースホルダー）",
    "searchPlaceholder": "ユーザーで検索…",
    "advanced": "詳細",
    "breakGlassOnly": "緊急アクセスのみ",
    "fromTo": "開始 / 終了：",
    "fromDate": "開始日",
    "toDate": "終了日",
    "clearFilters": "すべてのフィルターをクリア",
    "entriesFound": "{{count}} 件のエントリが見つかりました",
    "noMatch": "フィルター条件に一致する監査エントリはありません",
    "viewDetails": "詳細を表示",
    "detail": {
      "title": "監査エントリ詳細",
      "timestamp": "タイムスタンプ",
      "user": "ユーザー",
      "action": "操作",
      "resource": "リソース",
      "ipAddress": "IP アドレス",
      "breakGlass": "緊急アクセス",
      "yes": "はい",
      "no": "いいえ",
      "details": "詳細",
      "dataChanges": "データ変更",
      "before": "変更前",
      "after": "変更後",
      "result": "結果"
    },
    "columns": {
      "timestamp": "タイムスタンプ",
      "user": "ユーザー",
      "action": "操作",
      "resource": "リソース",
      "resourceId": "リソース ID",
      "ipAddress": "IP アドレス",
      "details": "詳細",
      "view": "表示"
    },
    "filter": {
      "action": {
        "all": "すべての操作",
        "create": "作成",
        "read": "参照",
        "update": "更新",
        "delete": "削除",
        "login": "ログイン",
        "logout": "ログアウト",
        "export": "エクスポート",
        "breakGlass": "緊急アクセス"
      },
      "resource": {
        "all": "すべてのリソース",
        "patient": "患者",
        "encounter": "受診",
        "order": "オーダー",
        "result": "結果",
        "medication": "投薬",
        "user": "ユーザー",
        "system": "システム"
      }
    },
    "pagination": {
      "first": "最初",
      "last": "最後",
      "pageOf": "{{pages}} ページ中 {{page}} ページ",
      "range": "{{total}} 件中 {{from}}-{{to}}"
    }
  },
  "taxonomy": {
    "title": "臨床タクソノミー",
    "subtitle": "サービスラインは関連する診療サービスをグループ化します(Cardiovascular → Cardiology、EP Lab、Heart Failure Clinic)。いずれもスケジューリングで使用するサービス ↔ ロケーション割り当てマトリクスに反映されます。",
    "addServiceLine": "サービスラインを追加",
    "addClinicalService": "診療サービスを追加",
    "tabs": {
      "serviceLines": "サービスライン",
      "clinicalServices": "診療サービス"
    },
    "searchLines": "サービスラインを検索...",
    "searchServices": "診療サービスを検索...",
    "empty": {
      "linesNone": "サービスラインが設定されていません。",
      "linesNoMatch": "該当するサービスラインがありません。",
      "servicesNone": "診療サービスが設定されていません。",
      "servicesNoMatch": "該当する診療サービスがありません。"
    },
    "columns": {
      "name": "名称",
      "code": "コード",
      "description": "説明",
      "services": "サービス数",
      "status": "ステータス",
      "serviceLine": "サービスライン",
      "specialty": "専門科",
      "actions": "操作"
    },
    "status": {
      "active": "有効",
      "inactive": "無効"
    },
    "editTitle": "編集"
  },
  "systemStatus": {
    "connected": "接続済み",
    "error": "エラー"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "{{count}} 名配置",
      "unstaffedBadge": "担当者なし",
      "unstaffedWarning": "次のロールには担当者がいないため、該当階層では誰も呼び出されません：{{roles}}。「管理 → ユーザー」でロールを割り当ててください。"
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
